// extracted by mini-css-extract-plugin
var _1 = "Icons_large__0f656";
var _2 = "Icons_medium__3dae0";
var _3 = "Icons_mini__8b251";
var _4 = "Icons_root__35416";
var _5 = "Icons_xmini__e2845";
export { _1 as "large", _2 as "medium", _3 as "mini", _4 as "root", _5 as "xmini" }
